"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TableFieldModel {
    constructor(name, label = '', isSortable = false, formatter = value => (value ? String(value) : ''), options = {}, index) {
        this.name = name;
        this.label = label;
        this.isSortable = isSortable;
        this.formatter = formatter;
        this.options = options;
        this.index = index;
    }
    format(item) {
        return this.formatter(item[this.name]);
    }
}
exports.TableFieldModel = TableFieldModel;
//# sourceMappingURL=TableFieldModel.js.map